<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button routerLink="/facilities/employeeDetails" routerLinkActive="active"
                (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Search Employee Details</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="container">
        <form action="/action_page.php">
            <div class="container-row-input">
                <div>
                    <label for="name"><b>Employee Name</b> </label>
                    <input type="text" id="name" name="name" required [(ngModel)]="query">
                </div>
                </div>
            <div>
                <input type="submit" value="View Employee Details" (click)="filter()">
            </div>
        </form>
    </div>
    <app-employee-table [employee]="employeeFiltered"></app-employee-table>
</div>